import React, { useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import { Card, Stack } from "react-bootstrap";
import { useIsAuthenticated } from "@azure/msal-react";
import { SignInButton } from "../components/SignInButton";
import { SignOutButton } from "../components/SignOutButton";
import { useMsal } from "@azure/msal-react";
import { PrimaryButton } from "@fluentui/react/lib/Button";
import { useNavigate } from "react-router-dom";
import { Text } from "@fluentui/react";
import { ExpiredTokenPopup } from "../components/ExpiredTokenPopup";

function MainPage(props) {
  const { setTokenExpired, tokenExpired, hasAdminRights, userSignedIn, setUserSignedIn } =
    props;
  const { accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [isActivating, setIsActivating] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [isProvisioned, setIsProvisioned] = useState(false);

  const navigate = useNavigate();

  const name = accounts[0] && accounts[0].name;
  
  function redirectToUserManagement() {
    navigate("/usermanagement");
  }

  function redirectToLicenseManagement() {
    navigate("/licensemanagement");
  }

  return (
    <>
    {tokenExpired && userSignedIn ? <ExpiredTokenPopup setTokenExpired={setTokenExpired} />: null}
      <Navbar
        style={{
          justifyContent: "left",
          borderBottom: "2px",
          borderColor: "black",
          backgroundColor: "#0066CC",
        }}
        variant="dark"
      >
        <a className="navbar-brand" href="/" style={{ marginLeft: "1rem" }}>
          novaCapta Compass Subscription Management
        </a>
        {isAuthenticated ? (
          <SignOutButton setTokenExpired={setTokenExpired} />
        ) : (
          <SignInButton setUserSignedIn={setUserSignedIn} setTokenExpired={setTokenExpired} />
        )}
      </Navbar>
      {isAuthenticated ? (
        <center style={{ height: "100vh" }}>
          <Stack>
            {hasAdminRights ? (
              <div style={{ marginTop: "2rem" }}>
                <h5>Hello, {name}. Where do you wish to go?</h5>
                <div>
                  <Card style={{ width: "50rem", marginTop: "2rem" }}>
                    <Card.Body>
                      <Card.Title>
                        <h1>User management</h1>
                      </Card.Title>
                      <Card.Text
                        style={{ marginTop: "2rem", marginBottom: "1rem" }}
                      >
                        <h5>
                          Manage the users that may use or administrate your
                          subscription.
                        </h5>
                      </Card.Text>
                    </Card.Body>
                    <Card.Footer style={{ backgroundColor: "white" }}>
                      <PrimaryButton
                        style={{
                          marginLeft: "40rem",
                          marginTop: "0.5rem",
                          marginBottom: "0.5rem",
                        }}
                        onClick={redirectToUserManagement}
                      >
                        Go
                      </PrimaryButton>
                    </Card.Footer>
                  </Card>
                </div>
                <div>
                  <Card style={{ width: "50rem", marginTop: "2rem" }}>
                    <Card.Body>
                      <Card.Title>
                        <h1>License Management</h1>
                      </Card.Title>
                      <Card.Text
                        style={{ marginTop: "2rem", marginBottom: "1rem" }}
                      >
                        <h5>
                          Manage your licenses - assign and revoke them from
                          users.
                        </h5>
                      </Card.Text>
                    </Card.Body>
                    <Card.Footer style={{ backgroundColor: "white" }}>
                      <PrimaryButton
                        style={{
                          marginLeft: "40rem",
                          marginTop: "0.5rem",
                          marginBottom: "0.5rem",
                        }}
                        onClick={redirectToLicenseManagement}
                      >
                        Go
                      </PrimaryButton>
                    </Card.Footer>
                  </Card>
                </div>
              </div>
            ) : (
              <div style={{ marginTop: "2rem" }}>
                <h5>
                  Welcome to the Subscription Management Center for novaCapta
                  Compass
                </h5>
                <Card style={{ width: "50rem", marginTop: "2rem" }}>
                  <Card.Body>
                    <Card.Title>
                      <h1>No valid subscription found.</h1>
                    </Card.Title>
                    <Card.Text
                      style={{ marginTop: "2rem", marginBottom: "2rem" }}
                    >
                      <h5>
                        It appears there is no valid subscription associated
                        with your tenant. <br />
                        <br />
                        You may purchase a subscription for novaCapta Compass
                        through the Microsoft AppSource store.
                      </h5>
                    </Card.Text>
                  </Card.Body>
                </Card>
              </div>
            )}
          </Stack>
        </center>
      ) : (
        <center style={{ height: "100vh" }}>
          <div style={{ marginTop: "2rem" }}>
            <h5>
              Welcome to the Subscription Management Center for novaCapta
              Compass
            </h5>
            <Card style={{ width: "50rem", marginTop: "2rem" }}>
              <Card.Body>
                <Card.Title>
                  <h1>Please sign in.</h1>
                </Card.Title>
                <Card.Text style={{ marginTop: "2rem", marginBottom: "2rem" }}>
                  <h5>
                    If you do not yet own an active subscription, you may
                    purchase one from the Microsoft AppSource Store.
                  </h5>
                </Card.Text>
              </Card.Body>
            </Card>
          </div>
        </center>
      )}
      <Navbar
        style={{
          justifyContent: "center",
          marginTop: "3.5rem",
          borderColor: "black",
          backgroundColor: "#0066CC",
        }}
        variant="dark"
      >
        <Text style={{ color: "white" }}>©2021 novaCapta GmbH</Text>
      </Navbar>
    </>
  );
}

export default MainPage;
